import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PayrollInformationBO,WorkHistoryBO } from './employee-payroll.model';
import { ErrorService } from 'src/app/service/error.service';

@Injectable()
export class EmployeePayrollService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  saveemployeepayroll(saveList: PayrollInformationBO): Observable<any> {
    let url = "api/PayrollInformation/SavePayInformation";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveemployeeworkhistory(saveList: WorkHistoryBO):Observable<any>{
    let url = "api/WorkHistory/SaveWorkHistory";
        return this.http.post(url, saveList, { observe: 'response',responseType: "text"},).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetClientDropdown(): Observable<any> {
    let url = "api/Client/clientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
 ///////////////////////////////get PayCheckTYpe//////////////////////////////////////////////////////////////
 getPayCheckType(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
  let url = "api/LOV/getLovDropDown?";
  return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
//////////////////////////////get Maritial  Type///////////////////////////////////////////////////////////////////
getMaritialStatus(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
  let url = "api/LOV/getLovDropDown?";
  return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
 ///////////////get payroll Information//////////////////////////////////

 getpayrollInfrom(paramsData: URLSearchParams): Observable<PayrollInformationBO> {
  let url = "api/PayrollInformation/GetPayInformation?"
  return this.http.get<PayrollInformationBO>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )

}
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ShowEmployeePayrolldata(value: any): Observable<any> {
    let url = "api/Employee/ShowPassBankAccount";
    return this.http.post(url, value, { observe: 'response', responseType: 'text' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}